import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { SanityLink } from "#components";
import { h } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentSanity',
  props: {
    blocks: {},
    page: {}
  },
  setup(__props: any) {



function wrapHeading(props, tag) {
  const { children } = props;
  const headingId = `h-${props.id}`;
  const content = Array.isArray(children) ? children.map((child) => child.text).join(" ") : "";

  const headingClasses = {
    h1: "text-4xl md:text-5xl font-bold tracking-tight my-8",
    h2: "text-3xl md:text-4xl font-bold tracking-tight my-6",
    h3: "text-2xl md:text-3xl font-bold tracking-tight my-4",
    h4: "text-xl md:text-2xl font-bold tracking-tight my-2",
  };

  return h(
    tag,
    {
      id: headingId,
      class: `scroll-mt-[calc(48px+48px+var(--header-height))] lg:scroll-mt-[calc(48px+var(--header-height))] relative ${headingClasses[tag]}`,
    },
    [
      h(
        "a",
        {
          "aria-current": "page",
          href: `/${__props.page}/#${headingId}`,
          class: "router-link-active router-link-exact-active group",
        },
        [
          h(
            "div",
            {
              class:
                "-ml-6 pr-2 py-2 inline-flex opacity-0 group-hover:lg:opacity-100 transition-opacity absolute",
            },
            [
              h("span", {
                class: "iconify i-heroicons:hashtag-20-solid w-4 h-4 text-(--ui-primary)",
                "aria-hidden": true,
              }),
            ],
          ),
          content,
        ],
      ),
    ],
  );
}

function _wrapNormal(props) {
  const { children } = props;

  return h(
    "p",
    children.map((child) => {
      return child.text;
    }),
  );
}

const serializers = {
  styles: {
    h1: (props) => wrapHeading(props, "h1"),
    h2: (props) => wrapHeading(props, "h2"),
    h3: (props) => wrapHeading(props, "h3"),
    h4: (props) => wrapHeading(props, "h4"),
    blockquote: (props) => {
      const { children } = props;
      const content = Array.isArray(children) ? children.map((child) => child.text).join(" ") : "";
      return h(
        "blockquote",
        {
          class: `text-xl font-semibold not-italic w-full p-5 border border-primary-100 dark:border-slate-800
        dark:bg-[linear-gradient(to_bottom,transparent_0%_1.3em,theme(colors.slate.800)_1.4em),linear-gradient(to_right,transparent_0%_1.3em,theme(colors.slate.800)_1.4em)]
        bg-[linear-gradient(to_bottom,transparent_0%_1.3em,theme(colors.primary.100)_1.4em),linear-gradient(to_right,transparent_0%_1.3em,theme(colors.primary.200)_1.4em)] bg-[length:1.4em_1.4em]`,
        },
        `❝${content}❞`,
      );
    },
    // normal: (props) => wrapNormal(props),
  },
  marks: {
    // link:  (props) => wrapLinks(props),
    link: (props: any, children: any) => {
      return h(SanityLink, { href: props.href }, children.slots);
    },
    internalLink: (props: any, children: any) => {
      return h(SanityLink, { href: props.href }, children.slots);
    },
  },
  types: {
    // image: (props) => { // need to use sanityImage component to auto choose the best image.
    //   return h("img", { src: urlFor(props).url(), loading: 'lazy', alt: 'FamilyAxis blog', class: 'rounded-xl  my-5' })
    // },
    adsense: () => {
      return h("div", { class: "my-10 flex justify-center" }, [
        h("ins", {
          class: "adsbygoogle",
          style: "display:block; text-align:center;",
          "data-ad-layout": "in-article",
          "data-ad-format": "fluid",
          "data-ad-client": "ca-pub-1226910964236070",
          "data-ad-slot": "4010344841",
        }),
      ]);
    },
  },
};

return (_ctx: any,_cache: any) => {
  const _component_SanityContent = _resolveComponent("SanityContent")!
  const _component_UPageBody = _resolveComponent("UPageBody")!

  return (_openBlock(), _createBlock(_component_UPageBody, {
    prose: "",
    class: "content-sanity space-y-2"
  }, {
    default: _withCtx(() => [
      (__props.blocks)
        ? (_openBlock(), _createBlock(_component_SanityContent, {
            key: 0,
            value: __props.blocks as any,
            components: serializers
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})